export const updatePasswordEnLocale = {
  'update-password.title': 'Update Password',
  'update-password.current-password': 'Current Password',
  'update-password.new-password': 'New Password',
  'update-password.confirm-password': 'Confirm Password',

  'update-password.submit': 'Update Password',
  'update-password.submitting': 'Updating Password...',
  'update-password.success': 'Password updated successfully!',
  'update-password.error': 'Incorrect current password. Please try again.',

  'update-password.current-password.required':
    'Please enter your current password.',

  'update-password.new-password.required': 'Please enter your new password.',
  'update-password.new-password.min':
    'Password must be at least 8 characters long.',
  'update-password.new-password.max':
    'Password must be at most 32 characters long.',

  'update-password.confirm-password.required':
    'Please confirm your new password.',
  'update-password.confirm-password.match': 'Passwords do not match.',
} as const;

export const updatePasswordEsLocale = {
  'update-password.title': 'Actualizar Contraseña',
  'update-password.current-password': 'Contraseña Actual',
  'update-password.new-password': 'Nueva Contraseña',
  'update-password.confirm-password': 'Confirmar Contraseña',

  'update-password.submit': 'Actualizar Contraseña',
  'update-password.submitting': 'Actualizando Contraseña...',
  'update-password.success': '¡Contraseña actualizada con éxito!',

  'update-password.error':
    'Contraseña actual incorrecta. Por favor, inténtelo de nuevo.',

  'update-password.current-password.required':
    'Por favor, introduzca su contraseña actual.',
  'update-password.new-password.required':
    'Por favor, introduzca su nueva contraseña.',
  'update-password.new-password.min':
    'La contraseña debe tener al menos 8 caracteres.',
  'update-password.new-password.max':
    'La contraseña debe tener como máximo 32 caracteres.',

  'update-password.confirm-password.required':
    'Por favor, confirme su nueva contraseña.',
  'update-password.confirm-password.match': 'Las contraseñas no coinciden.',
} as const;
